<template>
<div class="card">
  <h6>YOUR CURRENT ENERGY SUPPLY</h6>
  <h4>Do you have the same supplier for gas & electricity?</h4>

   <div class="row">
      <div class="col-xs-6 col-md-3">
         <radio-button
            v-model="quote.sameSupplier"
            value="yes"
            :error="$v.sameSupplier.$error">Yes</radio-button>
      </div>

      <div class="col-xs-6 col-md-3">
         <radio-button
            v-model="quote.sameSupplier"
            value="no"
            :error="$v.sameSupplier.$error">No</radio-button>
      </div>
   </div>
</div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';

import { mapState, mapActions } from 'vuex';

export default {
  name: 'SameSupplier',
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote
    })
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss">
</style>
